module.exports = __webpack_public_path__ + "files/2dffc87573a6d6dd440e801b5cce5c8e.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Regular.woff
// module id = 1662
// module chunks = 60